import { render, staticRenderFns } from "./BookCoach.vue?vue&type=template&id=7a80b966"
import script from "./BookCoach.vue?vue&type=script&lang=js"
export * from "./BookCoach.vue?vue&type=script&lang=js"
import style0 from "./BookCoach.vue?vue&type=style&index=0&id=7a80b966&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports